var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card p-05" }, [
    _c("div", { staticClass: "card-container" }, [
      _c("div", { staticClass: "d-inline-flex p-2" }, [
        _c("div", [
          _c("div", {}, [_c("h3", [_vm._v(_vm._s(_vm.plan.title))])]),
          _vm._v(" "),
          _vm.plan.type === "company"
            ? _c("div", [
                _c("p", [
                  _c("i", { staticClass: "feather icon-users" }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.plan.num_individuals === 0
                          ? "Unlimited"
                          : _vm.plan.num_individuals
                      ) +
                      " Users"
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "font-weight-bolder font-size-medium" },
            [
              _vm.plan.price === 0
                ? _c("div", [
                    _vm._v(
                      "\n                        Free\n                    "
                    ),
                  ])
                : [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm._f("currency")(_vm.plan.price, _vm.site_tax)
                        ) +
                        " / " +
                        _vm._s(_vm.plan.interval) +
                        "\n                    "
                    ),
                  ],
            ],
            2
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "mt-05",
            domProps: { innerHTML: _vm._s(_vm.plan.description) },
          }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.plan.plan_features.length > 0 && _vm.show_features
      ? _c(
          "div",
          { staticClass: "card-body" },
          [
            _c("plan-features", {
              attrs: { plan_features: _vm.plan.plan_features },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-footer border-0 bg-white mt-auto" },
      [
        _vm.user_current_plan &&
        _vm.user_current_plan.stripe_plan_id === _vm.plan.stripe_plan_id &&
        !_vm.user_part_of_company
          ? [
              _vm.user_subscription !== null &&
              _vm.user_subscription.ends_at !== null
                ? [
                    _c("p", { staticClass: "text-primary" }, [
                      _vm._v(
                        _vm._s(_vm.__("plan.form.paragraph.subscription_end")) +
                          " " +
                          _vm._s(_vm.formatDate(_vm.user_subscription.ends_at))
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary mt-1 btn-block mt-auto",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.resumeSubscription()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.__("plan.form.links.resume")) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                : _vm.plan.price === 0
                ? _c(
                    "button",
                    { staticClass: "btn btn-success mt-1 mb-0 btn-block" },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.__("plan.form.paragraph.your_current_plan")
                          ) +
                          "\n            "
                      ),
                    ]
                  )
                : _c(
                    "button",
                    {
                      staticClass: "btn btn-danger mt-1 btn-block mt-auto",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.cancelSubscription()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.__("plan.form.buttons.cancel")) +
                          "\n            "
                      ),
                    ]
                  ),
            ]
          : _vm.company_owner
          ? _c(
              "button",
              {
                staticClass: "btn btn-primary mt-1 btn-block mt-auto",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.plan.type === "company"
                      ? _vm.upgradeCompany(_vm.plan.plan_link)
                      : _vm.changeIndividual(_vm.plan.plan_link)
                  },
                },
              },
              [
                _vm._v(
                  "\n             " +
                    _vm._s(
                      _vm.plan.price === 0
                        ? _vm.__("plan.form.links.continue_upgrade")
                        : _vm.__("plan.form.links.purchase_this_upgrade")
                    ) +
                    "\n         "
                ),
              ]
            )
          : _c(
              "button",
              {
                staticClass: "btn btn-primary mt-1 btn-block mt-auto",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.user_part_of_company
                      ? _vm.removeCompanyPlan(_vm.plan.plan_link)
                      : _vm.upgradePlan(_vm.plan.plan_link)
                  },
                },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.plan.price === 0
                        ? _vm.__("plan.form.links.continue_upgrade")
                        : _vm.__("plan.form.links.purchase_this_upgrade")
                    ) +
                    "\n        "
                ),
              ]
            ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }